import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=6141abb4&scoped=true"
import script from "./infoCard.vue?vue&type=script&lang=js"
export * from "./infoCard.vue?vue&type=script&lang=js"
import style0 from "./infoCard.vue?vue&type=style&index=0&id=6141abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141abb4",
  null
  
)

export default component.exports